
import Vue from 'vue'
import i18n from '@/locales/_i18n';

const getDefaultState = () => {
    return {
        configuracaoSistema: {
            id: 0,
            qtdeDiasExpiracaoCotacaoDistribuidor: 0,
            qtdeDiasExpiracaoCotacaoInterno: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("configuracao-sistema/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listConfiguracaoSistema = result.data.result;

                return listConfiguracaoSistema;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar configurações do sistema: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`configuracao-sistema/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter configurações do sistema`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Erro ao obter configurações do sistema: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, configuracaoSistemaRequest) {

        try {
            const result = await Vue.prototype.$spTechApi.post(`configuracao-sistema/create-update`, configuracaoSistemaRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Registro atualizado com sucesso!";

                if (configuracaoSistemaRequest.id === 0) {
                    msg = "Registro criado com sucesso!";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}`
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error}]`
                };
            }
        }
    }
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.marca, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.marca;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
